import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const sensitivityColorMap = {
  1: '#1976d2', // blue
  2: '#fbc02d', // yellow
  3: '#f57c00', // orange
  4: '#7b1fa2', // purple
  5: '#00897b', // teal
  6: '#c2185b', // pink
  7: '#455a64', // gray
  8: '#afb42b', // lime
};

function getRangesWithOff(allPoints, uniqueSensitivities) {
  const hasOff = allPoints.some(pt => pt.weedItOff);
  const sensitivityRanges = uniqueSensitivities
    .filter(val => val >= 1 && val <= 8)
    .map(val => {
      const value = val.toString();
      return {
        min: value,
        max: value,
        color: sensitivityColorMap[value],
        value,
      };
    });
  if (hasOff) {
    return [
      {
        min: 'off',
        max: 'off',
        color: '#d32f2f',
        value: 'Weed-It Off',
        dashed: true,
      },
      ...sensitivityRanges
    ];
  }
  return sensitivityRanges;
}

export default function WeedItSensitivityOverlay({ routes }) {
  // routes: array of segments (arrays of points)
  const allPoints = useMemo(() => routes.flat(), [routes]);
  const uniqueSensitivities = useMemo(() => {
    const set = new Set();
    allPoints.forEach(pt => {
      if (
        pt.weedItSensitivity !== undefined &&
        pt.weedItSensitivity !== null &&
        pt.weedItSensitivity !== '' &&
        !isNaN(Number(pt.weedItSensitivity))
      ) {
        set.add(Number(pt.weedItSensitivity));
      }
    });
    return Array.from(set).sort((a, b) => a - b);
  }, [allPoints]);

  const finalRanges = useMemo(
    () => getRangesWithOff(allPoints, uniqueSensitivities),
    [allPoints, uniqueSensitivities]
  );

  // If weedItOff is true, treat as "off" (value 'off')
  const valueSelector = pt =>
    pt.weedItOff
      ? 'off'
      : pt.weedItSensitivity !== undefined &&
        pt.weedItSensitivity !== null &&
        pt.weedItSensitivity !== ''
      ? pt.weedItSensitivity.toString()
      : '';

  const legendFormatter = r => r.value;

  if (!allPoints.length) return null;

  return (
    <SegmentedPolylineOverlay
      segments={routes}
      valueSelector={valueSelector}
      ranges={finalRanges}
      legendTitle="Weed-It Sensitivity"
      legendFormatter={legendFormatter}
      units=""
      discrete={true}
    />
  );
}